// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-page{padding-top:8rem;padding-bottom:8rem}.error-page__content{text-align:center}.error-page__code{font-size:3.667rem;line-height:3rem;--tw-text-opacity:1;color:rgba(0,61,76,var(--tw-text-opacity))}@media (min-width:768px){.error-page__code{font-size:17rem;line-height:17rem}}.error-page__text{max-width:700px;margin-left:auto;margin-right:auto}", ""]);
// Exports
module.exports = exports;
